import tw from "twin.macro"

import { TextBlockStoryProps } from "components/dynamic"
import PrimaryButton from "components/Buttons/Primary"
import Section from "components/Section"
import Link from "next/link"
import { H2, H6 } from "styles/Text"
import Language from "components/Language"

const TextBlockStory = ({
  Anchor,
  Title,
  UpperTitle,
  Body,
  StoryLink,
  LinkText,
}: TextBlockStoryProps) => {
  return (
    <Section anchor={Anchor}>
      <div tw="text-center">
        {UpperTitle && <H6 tw="text-primary">{UpperTitle}</H6>}
        {Title && <H2 tw="mt-5">{Title}</H2>}
        {Body && <Language tw="text-dark-grey mt-5">{Body}</Language>}
        {StoryLink && (
          <Link href={StoryLink} passHref>
            <PrimaryButton tw="mt-7.5" as="a" target="_blank">
              {LinkText || "View Story"}
            </PrimaryButton>
          </Link>
        )}
      </div>
    </Section>
  )
}

export default TextBlockStory
